import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";

import { User } from "../../../pages/login/login.model";
import superAdminLoginService from "./superAdminLoginService";

interface SuperAdminForgotUsernameState {
  superAdminForgotUsernameData: any;
  isError: boolean;
  isSuccess: boolean;
  isLoading: boolean;
  message: string;
}

const initialState: SuperAdminForgotUsernameState = {
  superAdminForgotUsernameData: "",
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
};

//forgot username slice
export const superAdminForgotUsername = createAsyncThunk("auth/forgot-username", async (userData: User, thunkAPI) => {
  try {
    const response = await superAdminLoginService.superAdminForgotUsernameService(userData);
    if (response.isSuccess) {
      return response;
    } else {
      throw new Error(response.message);
    }
  } catch (error: any) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const superAdminForgotUsernameSlice = createSlice({
  name: "forgotUsername",
  initialState,
  reducers: {
    superAdminResetForgotUsername: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(superAdminForgotUsername.pending, (state, action: PayloadAction<any>) => {
        state.isLoading = true;
      })
      .addCase(superAdminForgotUsername.fulfilled, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.superAdminForgotUsernameData = action.payload;
      })
      .addCase(superAdminForgotUsername.rejected, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

export const { superAdminResetForgotUsername } = superAdminForgotUsernameSlice.actions;
